import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common'; 
import { ClarityModule } from '@clr/angular';

import { HeaderComponent } from './layout/header/header.component';
import { SidenavComponent } from './layout/sidenav/sidenav.component';
import { AlertComponent } from './layout/alert/alert.component';

@NgModule({
  declarations: [
    HeaderComponent,
    SidenavComponent,
    AlertComponent
  ],
  exports: [
    HeaderComponent,
    SidenavComponent,
    AlertComponent
  ],
  imports: [
    CommonModule,
    ClarityModule,
    RouterModule
  ]
})
export class CoreModule { }
